import { Injectable } from "@nestjs/common";
import { FgDamagesDto } from "./fg-damages-dto";
import { fgDamagesEntity } from "./fg-damages-entity";
@Injectable()

export class FgDamagesAdapter{
    public convertDtoToEntity(fgDto:FgDamagesDto,isUpdate:boolean=false):fgDamagesEntity{
        const fgentity =new fgDamagesEntity();
        fgentity.fgDamageId=fgDto.fgDamageId;
        fgentity.LocationId=fgDto.LocationId;
        fgentity.saleOrderId=fgDto.saleOrderId;
        fgentity.damageType=fgDto.damageType;
        fgentity.damageLevel=fgDto.damageLevel;
        fgentity.noOfCartons=fgDto.noOfCartons;
        fgentity.createdUser=fgDto.createdUser;
        fgentity.damageBy=fgDto.damageBy;
        fgentity.createdAt=fgDto.createdAt;
        fgentity.unitId=fgDto.unitId;
        fgentity.damageReason=fgDto.damageReason;
        fgentity.saleOrderItemId=fgDto.saleOrderItemId;
        fgentity.stockId=fgDto.stockId;
        fgentity.isActive=fgDto.isActive==undefined?true:fgDto.isActive;
        if (isUpdate) {
            fgentity.updatedUser = fgDto.updatedUser;
          } else {
            fgentity.isActive = true;
            fgentity.createdUser = fgDto.createdUser;
          }
         return fgentity;

    }
    public convertEntityToDto(fgObject: fgDamagesEntity): FgDamagesDto {
        const fgdto=new FgDamagesDto
        fgdto.fgDamageId=fgObject.fgDamageId;
        fgdto.LocationId=fgObject.LocationId;
        fgdto.damageBy=fgObject.damageBy;
        fgdto.saleOrderId=fgObject.saleOrderId;
        fgdto.damageLevel=fgObject.damageLevel;
        fgdto.damageType=fgObject.damageType;
        fgdto.createdAt=fgObject.createdAt;
        fgdto.createdUser=fgObject.createdUser;
        fgdto.versionFlag=fgObject.versionFlag;
        fgdto.updatedAt=fgObject.updatedAt;
        fgdto.updatedUser=fgObject.updatedUser;
        fgdto.damageReason=fgObject.damageReason;
        fgdto.saleOrderItemId=fgObject.saleOrderItemId;
        fgdto.stockId=fgObject.stockId;
        return fgdto

    }
}